export const STATE_COLORS = {
  New: 'neutral',
  Sent: 'primary',
  Submitted: 'success',
  Reopened: 'warning',
  'Sent · expired': 'neutral',
  'Reopened · expired': 'neutral'
};

export const STATE_OPTIONS = [
  'All states',
  'New',
  'Sent',
  'Submitted',
  'Reopened',
  'Sent · expired',
  'Reopened · expired'
].map(v => ({
  label: v,
  value: v
}));

export const PILOT_OPTIONS = [
  'All pilots',
  'Pilot: open',
  'Pilot: closed won',
  'Pilot: closed lost'
].map(v => ({
  label: v,
  value: v
}));

export const DATE_OPTIONS = ['Last 30 days', 'Last 90 days', 'This quarter', 'All time'].map(v => ({
  label: v,
  value: v
}));

export const ALL_USERS_OPTION = { label: 'All internal users', value: 'All internal users' };
